var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          ref: "table",
          attrs: {
            data: _vm.catList,
            "element-loading-text": "Loading",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            ref: "name",
            attrs: { label: "猫仙人名字", width: "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "cat-name",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.handleLink(scope.row.id)
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            ref: "name",
            attrs: { label: "封面图", width: "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("img", {
                      staticClass: "banner-img",
                      attrs: { src: scope.row.cat_img.banner_img }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "猫咪状态",
              width: "140",
              align: "center",
              filters: [
                { text: "可售卖", value: "可售卖" },
                { text: "可预订", value: "可预订" },
                { text: "种猫-非卖", value: "种猫-非卖" },
                { text: "下架", value: "下架" }
              ],
              "filter-method": _vm.filterStatusHandler,
              "filtered-value": ["可售卖", "可预订"],
              prop: "scope.row.status"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.status))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "生日", width: "140", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.birthday))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              "class-name": "status-col",
              label: "标签",
              width: "280",
              align: "center"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.tags, function(tag) {
                    return _c("el-tag", { key: tag }, [
                      _vm._v("\n            " + _vm._s(tag) + "\n          ")
                    ])
                  })
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }